var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearchMember(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSearchMember") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter-Copy-2",
    transform: "translate(-33.000000, -210.000000)",
    fill: "#AFAFAF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-more",
    transform: "translate(6.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SearchField",
    transform: "translate(12.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Search",
    transform: "translate(15.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.22954909,11.1749027 C3.27149909,11.1749027 0.864861279,8.85796192 0.864861279,6.00904374 C0.864861279,3.16087272 3.27149909,0.843931925 6.22954909,0.843931925 C9.1875991,0.843931925 11.5942369,3.16087272 11.5942369,6.00904374 C11.5942369,8.85796192 9.1875991,11.1749027 6.22954909,11.1749027 M10.4256615,10.0384735 C11.4956103,9.00515229 12.1590982,7.58031962 12.1590982,6.00904374 C12.1590982,2.86126187 9.49916941,0.3 6.22954909,0.3 C2.95992878,0.3 0.3,2.86126187 0.3,6.00904374 C0.3,9.15757277 2.95992878,11.7188346 6.22954909,11.7188346 C7.66486459,11.7188346 8.98212707,11.2249624 10.00874,10.4053287 L14.2138184,14.6163182 C14.2691091,14.6723551 14.343079,14.7 14.4177961,14.7 C14.4880302,14.7 14.5582643,14.6745966 14.6135549,14.6237898 C14.7256306,14.5199346 14.7293664,14.348088 14.6210266,14.2397499 L10.4256615,10.0384735 Z",
    id: "icSearchMember"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchMember);
export default __webpack_public_path__ + "static/media/icSearchMember.0b26707fd7ca5128cc55212a4755cf79.svg";
export { ForwardRef as ReactComponent };